import React from 'react';
import { Table } from 'react-bootstrap';
import Row from './components/Row';

const BidderSourcesTable = ({ config, sources, onUpdate, onFactors, onSort }) => {
    const rows = Object.keys(sources).map((source) => {
        const sourceName = sources[source];

        return <Row index={source} enabled={config[source]} source={source} sourceName={sourceName} onUpdate={onUpdate} onFactors={onFactors}/>
    })

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th onClick={() => onSort('source')}>Source</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default BidderSourcesTable;


// WEBPACK FOOTER //
// ./src/scenes/BidderWinRateConfig/components/Table/index.js